import { api } from "@/lib/api/client";
import type {
  ArtistDetailResponse,
  ArtistListResponse,
  ArtistListStatus,
  CreateArtistManualPayload,
  CreateArtistManualResponse,
  UpdateArtistPayload,
} from "./types";

const BASE = "/api/nexus/artists";

export const artistsMgmtApi = {
  list: async (params: {
    q?: string;
    status?: ArtistListStatus | "";
    page?: number;
    pageSize?: number;
  }): Promise<ArtistListResponse> => {
    const { data } = await api.get<ArtistListResponse>(BASE, { params });
    return data;
  },

  // Alta manual directa: crea o promueve la cuenta a artista + perfil de
  // catálogo. El artista solo tiene que entrar a su portal con su cuenta.
  createManual: async (
    payload: CreateArtistManualPayload,
  ): Promise<CreateArtistManualResponse> => {
    const { data } = await api.post<CreateArtistManualResponse>(BASE, payload);
    return data;
  },

  get: async (id: number): Promise<ArtistDetailResponse> => {
    const { data } = await api.get<ArtistDetailResponse>(`${BASE}/${id}`);
    return data;
  },

  update: async (id: number, payload: UpdateArtistPayload): Promise<void> => {
    await api.patch(`${BASE}/${id}`, payload);
  },

  softDelete: async (id: number): Promise<void> => {
    await api.post(`${BASE}/${id}/soft-delete`);
  },

  restore: async (id: number): Promise<void> => {
    await api.post(`${BASE}/${id}/restore`);
  },
};
